import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  currentStatus: {
    id: 'components.status.currentStatus',
    defaultMessage: 'Current Status',
  },
  progressToLevel: {
    id: 'components.status.progressToLevel',
    defaultMessage: 'Progress to <span class={nextLevel}>{nextLevel}</span> Level',
  },
  remainingToLevel: {
    id: 'components.status.remainingToLevel',
    defaultMessage: 'Remaining to <span class={nextLevel}>{nextLevel}</span> Level',
  },
});



// WEBPACK FOOTER //
// ./src/components/Status/messages.js